import React from 'react';
import ReactDOM from 'react-dom';
import CancelIcon from '@/assets/member-assets/homepage/x-close.svg';

interface ActionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: React.ReactNode;
  confirmButtonText: string;
  icon: string;
  iconBgClassName?: string;
  confirmButtonClassName?: string;
}

const MemberDefaultModel = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmButtonText,
  icon,
  iconBgClassName = 'bg-gray-100',
  confirmButtonClassName = 'bg-gray-900 hover:bg-gray-800',
}: ActionDialogProps) => {
  if (!isOpen) return null;

  const modalContent = (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-60 px-4">
      <div
        data-testid="memberModal_default"
        className="w-full max-w-sm rounded-3xl bg-white p-6 shadow-xl"
      >
        <div className="flex items-start justify-between">
          <div
            className={`flex h-12 w-12 items-center justify-center rounded-full ${iconBgClassName}`}
          >
            <img src={icon} alt={title} />
          </div>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-gray-600">
            <img src={CancelIcon} alt="Close" />
          </button>
        </div>

        <div className="mt-4">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          <div className="mt-1 text-sm text-gray-600">{description}</div>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3">
          <button
            type="button"
            data-testid="memberModal_defaultCancelBtn"
            onClick={onClose}
            className="w-full rounded-full border border-gray-300 bg-white px-4 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="button"
            data-testid="memberModal_defaultConfirmBtn"
            onClick={onConfirm}
            className={`w-full rounded-full px-4 py-2.5 text-sm font-semibold text-white shadow-sm ${confirmButtonClassName}`}
          >
            {confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default MemberDefaultModel;
